if (!customElements.get('a20-purchase-options')) {
    customElements.define('a20-purchase-options', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.form = this.closest('form');
        this.root = this.closest('[data-a20-purchase]');
        if (!this.form || !this.root) return;
        this.qty = this.form.querySelector('[name="quantity"]');
        this.main = this.form.querySelector('[data-dps-main-add]');
        this.action = this.querySelector('[data-a20-add]');
        this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency});
        this.onChange = (event) => { if (event.target.matches('[data-a20-option]')) this.sync(true); };
        this.onQty = () => this.sync(false);
        this.addEventListener('change', this.onChange);
        this.qty?.addEventListener('input', this.onQty);
        this.qty?.addEventListener('change', this.onQty);
        this.action.addEventListener('click', () => this.main?.click());
        this.sync(true);
        this.action.hidden = false;
      }
      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.qty?.removeEventListener('input', this.onQty);
        this.qty?.removeEventListener('change', this.onQty);
        this.ready = false;
      }
      sync(selectionChanged) {
        const option = this.querySelector('[data-a20-option]:checked');
        if (!option || !this.main) return;
        const isBase = option.value === this.dataset.baseId;
        const data = option.dataset;
        const variantInput = this.form.querySelector('input[name="id"]');
        if (variantInput) { variantInput.value = option.value; variantInput.disabled = false; }
        if (this.qty && selectionChanged) {
          this.qty.min = data.min; this.qty.step = data.step;
          if (data.max) this.qty.max = data.max; else this.qty.removeAttribute('max');
          const min = Number(data.min), step = Number(data.step);
          let quantity = Math.max(min, Number(this.qty.value) || min);
          quantity = min + Math.ceil((quantity - min) / step) * step;
          if (data.max) quantity = Math.min(quantity, Number(data.max));
          this.qty.value = String(quantity);
        }
        const quantity = Math.max(1, Number(this.qty?.value) || 1);
        const total = this.formatter.format(Number(data.price) * quantity / 100);
        this.form.querySelectorAll('input[name^="shopify-additional-items["][name$="[parent_id]"]').forEach((parent) => {
          const enabled = parent.value === option.value;
          parent.disabled = !enabled;
          const id = this.form.elements.namedItem(parent.name.replace('[parent_id]', '[id]'));
          if (id) id.disabled = !enabled;
        });
        const giftNote = this.root.querySelector('[data-dpg-note]');
        if (giftNote) giftNote.hidden = !this.form.querySelector('input[name^="shopify-additional-items["]:not([disabled])');
        const price = this.root.querySelector('[data-dps-price]');
        if (price) {
          let label = price.querySelector('.a20buy-price-label');
          if (!label) { label = document.createElement('p'); label.className = 'a20buy-price-label'; price.prepend(label); }
          label.textContent = data.title + ' · ' + this.dataset.perKit;
          const line = price.querySelector('.dps-price-line');
          if (line) {
            line.querySelector('strong').textContent = data.formatted;
            let compare = line.querySelector('s');
            if (Number(data.compare) > Number(data.price)) {
              if (!compare) { compare = document.createElement('s'); line.append(compare); }
              compare.textContent = data.compareFormatted;
            } else if (compare) compare.remove();
          }
          price.querySelector('.dps-saving')?.remove();
          let saving = price.querySelector('.a20buy-price-saving');
          if (!saving) { saving = document.createElement('p'); saving.className = 'a20buy-price-saving'; price.append(saving); }
          saving.hidden = Number(data.compare) <= Number(data.price);
          saving.textContent = data.saving;
        }
        this.querySelector('[data-a20-selection]').textContent = (quantity > 1 ? quantity + ' × ' : '') + data.title;
        this.querySelector('[data-a20-total]').textContent = total + ' ' + this.dataset.currency;
        const buttonText = (isBase ? this.dataset.add : this.dataset.addSet) + ' · ' + total;
        this.main.textContent = buttonText;
        this.action.textContent = buttonText;
        this.action.disabled = this.main.disabled;
        this.main.setAttribute('aria-label', buttonText + ' — ' + quantity + ' × ' + data.title);
        const stickyPrice = this.root.querySelector('[data-dps-fragment="sticky-price"]');
        if (stickyPrice) stickyPrice.textContent = total;
        const sticky = this.root.querySelector('[data-dps-sticky-add]');
        if (sticky) { sticky.textContent = buttonText; sticky.disabled = this.main.disabled; }
        this.root.querySelectorAll('.dps-buy-now,.dps-payment-terms,.dps-paypal-message').forEach((element) => { element.hidden = !isBase; });
      }
    });
  }
